export default __webpack_public_path__ + "static/media/profile-sp.1b51c0e6.webp";